const data= [
    { id: 1, label: 'Alteração de classe' },
    { id: 2, label: 'Pagamento integral por terceiro em processo judicial' },
    { id: 3, label: 'Pagamento parcial por terceiro em processo judicial' },
    { id: 4, label:  'Pagamento integral pelas Recuperandas em processo judicial' },
    { id: 5, label: 'Pagamento parcial pelas Recuperandas em processo judicial' },
    { id: 6, label: 'Bloqueio sem liberação em processo judicial'},
    { id: 7, label: 'Iliquido ou Incluir FGTS' },
    { id: 8, label: 'Bloqueio/Pagamento/Penhora' },
    { id: 9, label: 'Consta do sistema de AJ que a habilitação foi rejeitada - trabalhista/Iliquido ou Incluir FGTS' },
    { id: 10, label: 'Certidão de Crédito' },
    { id: 11, label: 'Incluir FGTS' },
    { id: 12, label: 'Sentença de liquidação transitada em julgado' },
    { id: 13, label: 'Iliquido' },
    { id: 14, label: 'Nome errado - Iliquido ou Incluir FGTS' },
    { id: 15, label: 'Não se sabe o motivo da alteração do valor' },
    { id: 16, label: 'Nome errado' },
    { id: 17, label: 'Incluir / Sistema AJ foi aprovado/Não consta da lista AJ/Sentença de liquidação' },
    { id: 18, label: 'Pedido de Hab não localizado no sistema AJ' },
    { id: 19, label: 'quirografário' },
    { id: 20, label: 'Incluir / Sistema AJ foi aprovado/Não consta da lista AJ/Incluir GTS' },
    { id: 21, label: 'Consta do sistema de AJ que a habilitação foi rejeitada - trabalhista' },
    { id: 22, label: 'Iliquido/Sem justificativa o valor' },
    { id: 23, label: 'Incluir' },
    { id: 24, label: 'Nome errado/Iliquido'},
    { id: 25, label: 'Incluir/Certidão de Crédito' },
    { id: 26, label: 'Iliquido/Cálculo não homologado' },
    { id: 27, label: 'Falta acrescentar TRCT da 123' },
    { id: 28, label: 'Excluir' },
    { id: 29, label: 'Incluir / Sistema AJ foi aprovado/Não consta da lista AJ/Incluir FGTS' },
    { id: 30, label: 'Ilíquido' },

]

export default [...data]